/**
 * @desc 分页
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.IPage<defs.basics.BaseUnitResponseDto>>;
export function request(params: API.basics.baseUnit.page.Params, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/baseUnit/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
